import api from 'common/api'
import trackEvents from 'common/track-events'

import { fetchProspects } from './fetch-prospects'
import { toggleFollow } from './toggle-follow'
import types from './types'

export const MY_PROSPECTS_URL = '/api/my_prospects?includeUserOrder=true'
export const USER_ORDER_URL = '/api/my_prospects/user_order'

const setTopChoices = (Order) => (dispatch) => {
  dispatch({ type: types.SET_TOP_CHOICES_START })
  return api
    .post(USER_ORDER_URL, { Order })
    .then(() => {
      dispatch({ type: types.SET_TOP_CHOICES_SUCCESS })
    })
    .catch(() => {
      dispatch({ type: types.SET_TOP_CHOICES_FAILURE })
    })
}

const TOP_CHOICES = 'top_choices'
const ADD_TYPE = 'add'
const UNRANK_TYPE = 'unrank'
const REORDER_TYPE = 'reorder'

const EVENT_TYPES = {
  [ADD_TYPE]: 'top_choices_add',
  [UNRANK_TYPE]: 'top_choices_unrank',
  [REORDER_TYPE]: 'top_choices_reorder',
}

const getTopChoicesEventConfig = (list, scid, EventSourceReferrer, type) => ({
  EventSourceReferrer,
  EventData: {
    scid,
    list,
  },
  DomainType: TOP_CHOICES,
  EventType: EVENT_TYPES[type],
})

const trackTopChoices =
  ({ types, eventsPayload }) =>
  (dispatch) => {
    dispatch({ type: types.start })
    return trackEvents(eventsPayload)
      .then(() => {
        dispatch({ type: types.success })
      })
      .catch(() => {
        dispatch({ type: types.failure })
      })
  }

const addTopChoice = (location, scid, list) =>
  trackTopChoices({
    types: {
      start: types.TRACK_ADD_TOP_CHOICES_START,
      success: types.TRACK_ADD_TOP_CHOICES_SUCCESS,
      failure: types.TRACK_ADD_TOP_CHOICES_FAILURE,
    },
    eventsPayload: getTopChoicesEventConfig(list, scid, location, ADD_TYPE),
  })

const removeTopChoice = (location, scid, list) =>
  trackTopChoices({
    types: {
      start: types.TRACK_REMOVE_TOP_CHOICES_START,
      success: types.TRACK_REMOVE_TOP_CHOICES_SUCCESS,
      failure: types.TRACK_REMOVE_TOP_CHOICES_FAILURE,
    },
    eventsPayload: getTopChoicesEventConfig(list, scid, location, UNRANK_TYPE),
  })

const reorderTopChoices = (location, scid, list) =>
  trackTopChoices({
    types: {
      start: types.TRACK_REORDER_TOP_CHOICES_START,
      success: types.TRACK_REORDER_TOP_CHOICES_SUCCESS,
      failure: types.TRACK_REORDER_TOP_CHOICES_FAILURE,
    },
    eventsPayload: getTopChoicesEventConfig(list, scid, location, REORDER_TYPE),
  })

const actions = {
  fetchProspects,
  setTopChoices,
  addTopChoice,
  removeTopChoice,
  reorderTopChoices,
  toggleFollow,
}

export default actions
